// Support: Select

import React, { FC } from 'react';
import { getIn } from 'formik';
import { FormHelperText } from '@mui/material';

export const withFormik = (Component: FC<any>) => (props: any) => {
	const { field, form, ...rest } = props;
	const touched = getIn(form.touched, field.name);
	const error = getIn(form.errors, field.name);
	return (
		<>
			<Component
				{...field}
				{...rest}
				form={form}
				error={!!touched && !!error}
			/>
			{error && touched && (
				<FormHelperText
					component="span"
					error
					margin="dense"
					sx={{ marginLeft: '14px' }}
				>
					{error}
				</FormHelperText>
			)}
		</>
	);
};

export default withFormik;
